import { render, staticRenderFns } from "./email-template-front.vue?vue&type=template&id=4d20286a&scoped=true&"
import script from "./email-template-front.vue?vue&type=script&lang=js&"
export * from "./email-template-front.vue?vue&type=script&lang=js&"
import style0 from "./email-template-front.vue?vue&type=style&index=0&id=4d20286a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20286a",
  null
  
)

export default component.exports